type ConfirmCallback = (hasAccepted: boolean) => void;

export function useConfirm(): {
  show: (title: string, callback: ConfirmCallback) => void;
} {
  return {
    show: (title: string, callback: ConfirmCallback): void => {
      callback(confirm(title));
    }
  };
}
